import React from 'react';
// reactstrap components
import { Card, CardHeader, CardBody, CardTitle } from 'reactstrap';
import { useTranslate } from 'react-translate';
import InvitationList from 'components/MedicalRep/InvitationList';

const InvitationsListView = () => {
  const t = useTranslate('medical-rep');

  return (
    <>
      <Card className="profile">
        <CardBody>
          <Card className="mb-0">
            <CardHeader>
              <CardTitle className="d-flex align-content-center">
                <div className="general-card-title-img text-primary mr-2">
                  <i className="icon-user-active" />
                </div>
                <div className="general-card-title text-primary">
                  {t('list-title')}
                </div>
              </CardTitle>
            </CardHeader>

            <CardBody>
              <InvitationList />
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </>
  );
};

export default InvitationsListView;
